export interface McpSignupAttribution {
  source: string;
  medium: 'mcp';
}

// Marketing labels only: never copy arbitrary query fields or OAuth material.
export function captureMcpSignupAttribution(params: URLSearchParams): McpSignupAttribution | undefined {
  const source = params.get('utm_source');
  if (params.get('utm_medium') !== 'mcp' || !['chatgpt.com', 'mcp-local', 'mcp-unknown'].includes(source)) return undefined;
  return { source, medium: 'mcp' };
}

export function mergeMcpSignupAttribution(existing: unknown, attribution?: McpSignupAttribution): unknown {
  if (!attribution) return existing;
  // Preserve campaign/click attribution but replace source/medium for this signup.
  // Never carry a previously captured navigation URL into an MCP conversion.
  const preserved = Array.isArray(existing) ? existing.filter(entry => entry &&
    !['utm_source', 'utm_medium', 'redirectUrl'].includes(entry.type)) : [];
  return [...preserved,
    { type: 'utm_source', value: { utm_source: attribution.source } },
    { type: 'utm_medium', value: { utm_medium: attribution.medium } },
  ];
}
